module.exports = __webpack_public_path__ + "static/media/international-homes-logo.ee3218cd.svg";